import { del, get, post, put } from '@utils/xhr';

export const isPasswordConfirmed = async () => {
  try {
    const response = await get({ url: `${process.env.apiPath}/user/confirmed-password-status` });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateUserPassword = async (currentPassword, password, newPassword) => {
  try {
    const response = await put({
      url: `${process.env.apiPath}/user/password`,
      data: {
        current_password: currentPassword,
        password,
        password_confirmation: newPassword
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const confirmUserPassword = async (password) => {
  try {
    const response = await post({
      url: `${process.env.apiPath}/user/confirm-password`,
      data: { password },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getTwoFactorAuthQr = async () => {
  try {
    const response = await get({ url: `${process.env.apiPath}/user/two-factor-qr-code` });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getTwoRecoveryCodes = async () => {
  try {
    const response = await get({ url: `${process.env.apiPath}/user/two-factor-recovery-codes` });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const twoFactorChallenge = async (code) => {
  try {
    const response = await post({ url: `${process.env.apiPath}/two-factor-challenge`, data: { code } });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const twoFactorRecoveryCodes = async (recoveryCode) => {
  try {
    const response = await post({ url: `${process.env.apiPath}/two-factor-challenge`, data: { recovery_code: recoveryCode } });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const enableTwoFactorAuth = async () => {
  try {
    const response = await post({ url: `${process.env.apiPath}/user/two-factor-authentication` });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const disableTwoFactorAuth = async () => {
  try {
    const response = await del({ url: `${process.env.apiPath}/user/two-factor-authentication` });
    return response;
  } catch (error) {
    return error.response;
  }
};

class AuthApi {
  constructor() {
    this.path = process.env.apiPath;
  }

  async login({ email, password }) {
    try {
      await get({ url: `${this.path}/sanctum/csrf-cookie` });
      const response = await post({
        url: `${this.path}/login`,
        data: {
          email,
          password,
        },
      });
      return response.data;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }

  async logout() {
    try {
      const response = await post({ url: `${this.path}/logout` });
      return response.data;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }

  async me() {
    try {
      const response = await get({ url: `${this.path}/api/user` });
      return response.data;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }

  async permissions() {
    try {
      const response = await get({ url: `${this.path}/api/user/permission` });
      return response.data;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }

  async forgotPassword(email) {
    try {
      const response = await post({
        url: `${this.path}/forgot-password`,
        data: { email },
      });
      return response.data;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }

  async sendPasswordLink(email) {
    try {
      const response = await post({
        url: `${this.path}/api/user/reset-password`,
        data: { email },
      });
      return response;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }

  async resetPassword(email, password, passwordConfirmation, token) {
    try {
      const response = await post({
        url: `${this.path}/reset-password`,
        data: { email, password, password_confirmation: passwordConfirmation, token },
      });
      return response.data;
    } catch (err) {
      const stringError = err.response.data.message.join('\n');
      throw new Error(stringError);
    }
  }
}

export const authApi = new AuthApi();
